import { render, staticRenderFns } from "./AlertComp.vue?vue&type=template&id=cdcbe624"
import script from "./AlertComp.vue?vue&type=script&lang=js"
export * from "./AlertComp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports